/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { ProductSearchResult } from '@msdyn365-commerce/retail-proxy';
import * as React from 'react';
import { widgetType as WidgetType } from '../bazzarvoice-widget.props.autogenerated';

// tslint:disable-next-line: no-typeof-undefined
const IsClientSide = () => !!(typeof window !== 'undefined' && window.document && window.document.createElement);

type BazzarvoiceProps = {
    productInfo?: ProductSearchResult;
    widgetType?: WidgetType;
    className?: string;
};

const Bazzarvoice = (props: BazzarvoiceProps) => {
    const { productInfo, widgetType, className } = props;

    // Bazaarvoice doesn't render on server side
    if (!IsClientSide()) {
        return null;
    }

    const itemId = productInfo?.ItemId;
    if (!itemId || !widgetType) {
        return null;
    }

    return (
        <div className={`hei-bazzarvoice-widget ${className || ''}`}>
            <div data-bv-show={widgetType} data-bv-product-id={itemId} />
        </div>
    );
};

export default Bazzarvoice;
